import { Component, OnInit, AfterViewInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-builders',
    templateUrl: './builders.component.html',
    styleUrls: ['./builders.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BuildersComponent implements OnInit, AfterViewInit {

  id: number;

  constructor(private actRoute: ActivatedRoute) {
      this.id = this.actRoute.snapshot.params.id;
    }

  ngAfterViewInit() {
      console.log(this.id);
    }
  ngOnInit() {
  }

}
